module.exports = __webpack_public_path__ + "media/images/gallery/constellations/star_layer_off-451c0a70a825fe9868b795ba121f6462.jpg";